import script from "./InviteTeamMembersField.vue?vue&type=script&setup=true&lang=js"
export * from "./InviteTeamMembersField.vue?vue&type=script&setup=true&lang=js"

import "./InviteTeamMembersField.vue?vue&type=style&index=0&id=887d5ea2&lang=css"
import "./InviteTeamMembersField.vue?vue&type=style&index=1&id=887d5ea2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-887d5ea2"]])

export default __exports__